
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/camelcase */
import { defineComponent, reactive, ref, computed } from 'vue';
import { useToast } from "vue-toastification";
import { useStore } from 'vuex'
import copy from 'copy-to-clipboard'
import db from '../db'
import axios from 'axios'



export default defineComponent({
  name: 'Create',
  setup(){
    const store = useStore()
    const recent = computed(()=>{
      return store.state.recent
    })
    const customImg = ref<string>('')
    const toast = useToast()
    const orderName = ref<string>('')
    const optionInput = ref<string>('')
    const orderOptions = reactive({
      options: Array<string>()
    })
    
    const refKey = ref<string>('')
    const qrcodeUrl =ref<string>('')
    
    const ordersRef = db.database().ref('orders')


    const createOrder = (): void => {
      if(orderName.value.trim() === ''){
        toast.error('請輸入訂單名稱')
        return
      }

      const newOrder = {
        name: orderName.value,
        create: (new Date()).toString(),
        image: '',
        options: orderOptions.options,
      }

      const pushDB = ()=>{
        const order = ordersRef.push(newOrder)
        refKey.value = (order.key as string);
  
        const base = 'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https://proladon.github.io/WUO.io/%23/search/'
        
        qrcodeUrl.value = require('../assets/loading.gif')
        axios.get(base + refKey.value).then((res: any)=>{
          qrcodeUrl.value =  res.config.url
        })
  
        store.commit('ADD_RECENT', {
          name: newOrder.name,
          key: refKey.value
        })
      }
      
      const upload = (document.getElementById('image-upload') as any)
      
      if(customImg.value !== ''){
        const formData = new FormData();
        formData.append("image", upload.files[0]);
        axios.post('https://api.imgbb.com/1/upload', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            params:{
              key:'56ba44899d75f86a7bf2ef5d371b0093',
              expiration: 86400
            }
        })
        .then(res=>{
          newOrder.image = res.data.data.display_url
          pushDB()
        })
        .catch(error=>{
          toast.error(error)
        })
      }
      else{
        pushDB()
      }
    }


    const addOption = (): void => {
      const option = optionInput.value.trim()
      if(orderOptions.options.includes(option)) toast.warning('品項已存在')
      if (option !== '' && !orderOptions.options.includes(option)) {
        orderOptions.options.push(option)
        optionInput.value = ''
      }
    }


    const removeOption = (index: number): void => {
      orderOptions.options.splice(index, 1)
    }
    

    const copyToClipboard = (type: string): void => {
      if(type === 'link'){
        copy('https://proladon.github.io/WUO.io/#/search/' + refKey.value)
      }
      else if (type === 'key'){
        copy(refKey.value)
      }
      toast.success("已複製到剪貼簿")
    }


    const deleteRecnt = (index: number): void => {
      store.commit('REMOVE_RECENT', index)
      store.commit('UPDATE_RECENT')
    }

    const copyKey = (key: string): void => {
      copy(key)
      toast.success('已複製訂單編號')
    }

    const uploadImg = async (e: Event | any) =>{
      const file = e.target.files[0]
      if(file){
        const toBase64 = (file: File) => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        })
        customImg.value = await toBase64(file) as string
      }
    }

    const cancelImg = (): void => {
      customImg.value = ''
    }

    return{
      recent,
      customImg,
      qrcodeUrl,
      orderName,
      refKey,
      createOrder,
      optionInput,
      orderOptions,
      addOption,
      removeOption,
      copyToClipboard,
      copyKey,
      deleteRecnt,
      uploadImg,
      cancelImg,
    }
  }
});
